import api, { BASE_URL } from "../../api";
import fileDownload from "js-file-download";

const ORDER_BASE_URL = `${BASE_URL}/shop/admin/orders/`;

const IMAGE_UPLOAD_URL = pk => {
  return `${ORDER_BASE_URL}${pk}/upload-image/`;
};

const listOrders = context => {
  return api(context)
    .get(ORDER_BASE_URL)
    .then(response => response.data);
};

const getOrder = (context, key) => {
  return api(context)
    .get(`${ORDER_BASE_URL}${key}/`)
    .then(response => response.data);
};

const bulkExportOrders = (context, query) => {
  let url = !!query
    ? query.replace("/orders/", "/orders/export/")
    : `${PRODUCT_BASE_URL}export/`;
  return api(context)
    .get(url)
    .then(response => response.data)
    .then(data => {
      const today = new Date();
      const filename = `orders_${today.getFullYear()}_${today.getMonth() +
        1}_${today.getDate()}.csv`;
      fileDownload(data, filename);
      return data;
    });
};

const getTransactionHistory = (context, key) => {
  return api(context)
    .get(`${ORDER_BASE_URL}${key}/transaction-history/`)
    .then(response => response.data);
};

 const updateOrder = (context, order) => {
   return api(context)
     .patch(`${ORDER_BASE_URL}${order.key}/`, order)
     .then(response => response.data);
 };

 const insertOrder = (context, order) => {
   return api(context)
     .post(ORDER_BASE_URL, order)
     .then(response => response.data);
 };

const voidOrder = (context, key) => {
  return api(context)
    .post(`${ORDER_BASE_URL}${key}/void-order/`)
    .then(response => response.data);
};

const printOrder = (context, key, printType, printCount) => {
  return api(context)
    .post(`${ORDER_BASE_URL}${key}/print/`, {
      print_type: printType,
      print_count: printCount
    })
    .then(response => response.data);
};

export const order = {
  BASE_URL: ORDER_BASE_URL,
  list: listOrders,
  get: getOrder,
  update: updateOrder,
  insert: insertOrder,
  export: bulkExportOrders,
  voidOrder,
  printOrder,
  getTransactionHistory
};

export default order;
